import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
const encode = (data) => {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
};

function ContactComponent() {
  const { t } = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const { pathname } = useLocation();
  const fontColor = "text-slate-200"; // All environments are dark now
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitError(null);

    const netlifyData = encode({
      "form-name": "contact",
      ...formData,
    });

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: netlifyData,
    })
      .then(() => {
        setIsSubmitted(true);
        setFormData({ name: "", email: "", message: "" });
        setTimeout(() => setIsSubmitted(false), 5000);
      })
      .catch((error) => {
        console.error("Form submission error:", error);
        setSubmitError(
          "There was an error submitting your form. Please try again."
        );
        setIsSubmitted(false);
      });
  };
  return (
    <div
      className={`${
        pathname.includes("home")
          ? "rounded-md text-left xl:w-1/3 md:w-full sm:w-full"
          : "max-w-xl mx-auto bg-slate-800/80 border border-slate-700/80 p-6 md:p-8 rounded-2xl shadow-2xl text-left backdrop-blur-sm"
      }`}
    >
      {isSubmitted ? (
        <p className="text-center text-green-400 font-semibold py-4">
          {t(
            "contact.successMessage",
            "Dank u wel voor uw bericht! U hoort spoedig van ons."
          )}
        </p>
      ) : (
        <form
          name="contact"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          onSubmit={handleSubmit}
          className="space-y-6"
          netlify
        >
          <input type="hidden" name="form-name" value="contact" />

          <p className="hidden">
            <label>
              Don't fill this out if you're human:
              <input name="bot-field" onChange={handleChange} />
            </label>
          </p>

          {submitError && (
            <p className="text-center text-red-400 font-semibold">
              {submitError}
            </p>
          )}
          <div>
            <label
              htmlFor="name"
              className={`block text-sm font-medium ${fontColor} mb-1`}
            >
              {t("contact.formName", "Name")}
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 bg-slate-900 border border-slate-700/80 rounded-xl text-white shadow-inner focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition duration-150 placeholder-slate-600"
              placeholder={t("contact.formNamePlaceholder", "Your Name")}
            />
          </div>

          <div>
            <label
              htmlFor="email"
              className={`block text-sm font-medium ${fontColor} mb-1`}
            >
              {t("contact.formEmail", "Email")}
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 bg-slate-900 border border-slate-700/80 rounded-xl text-white shadow-inner focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition duration-150 placeholder-slate-600"
              placeholder={t("contact.formMailPlaceholder", "Your Email")}
            />
          </div>

          <div>
            <label
              htmlFor="message"
              className={`block text-sm font-medium ${fontColor} mb-1`}
            >
              {t("contact.formMessage", "Message")}
            </label>
            <textarea
              id="message"
              name="message"
              rows="4"
              value={formData.message}
              onChange={handleChange}
              required
              className="w-full px-4 py-2.5 bg-slate-900 border border-slate-700/80 rounded-xl text-white shadow-inner focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent transition duration-150 placeholder-slate-600"
              placeholder={t("contact.formMessagePlaceholder", "Your Message")}
            ></textarea>
          </div>

          <div>
            <button
              type="submit"
              className={`${
                pathname.includes("home") ? "w-full sm:w-1/2 bg-amber-600 hover:bg-amber-700" : "w-full bg-teal-600 hover:bg-teal-700"
              } inline-flex justify-center py-3 px-6 border border-transparent shadow-md text-sm font-bold rounded-full text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500 transition duration-300 transform hover:scale-[1.01]`}
            >
              {t("contact.formSend", "Send")}
            </button>
          </div>
        </form>
      )}
    </div>
  );
}

export default ContactComponent;
